import styled from '@emotion/styled';
import { ComponentProps, FC } from 'react';
import AdProductList from './AdProductList';
import Text from 'components/base/Text';
import { ProductCardProps } from 'components/common/ProductCard';
import { ProductCardItem } from 'components/common/ProductCard/product';
import ProductCardVirtualList from 'components/common/ProductCardVirtualList';
import { white } from 'styles';

interface ExposeCondition {
  column: number;
  max_count: number;
}

const AD_EXPOSE_CONDITION = {
  column: 3,
  max_count: 9,
};
interface Props extends ComponentProps<typeof ProductCardVirtualList> {
  ad_product_list: ProductCardItem[];
  ad_title: string;
}

/**
 * 검색된 상품 리스트 (광고 포함)
 * @component
 */
const SearchProductList: FC<Props> = ({ ad_product_list, ad_title, product_ubl, ...rest }) => {
  const ad_product_list_slice_column = getMultipleAdProductList(ad_product_list, AD_EXPOSE_CONDITION);

  const is_show_ad_info = ad_product_list.length > 0;

  const result_product_ubl = product_ubl && { ...product_ubl, object_section: 'ad_badge' };
  const ad_product_ubl = product_ubl && {
    ...product_ubl,
    object_section: 'top_ad_section',
    data: { ...product_ubl.data, column_count: AD_EXPOSE_CONDITION.column },
  };

  const search_product_padding = is_show_ad_info ? '0 16px 28px' : '8px 16px 28px';

  return (
    <SC.Container>
      {is_show_ad_info && (
        <>
          <AdProductList product_list={ad_product_list_slice_column} column={3} product_ubl={ad_product_ubl} />
          <Text className='best_product' color='gray_secondary' variant='title6_medium' as='p'>
            {ad_title}
          </Text>
        </>
      )}
      <ProductCardVirtualList
        start_index={ad_product_list_slice_column.length}
        product_ubl={result_product_ubl}
        padding={search_product_padding}
        {...rest}
      />
    </SC.Container>
  );
};

function getMultipleAdProductList(product_list: ProductCardProps[], expose_conditon: ExposeCondition) {
  const { column, max_count } = expose_conditon;
  if (product_list.length > max_count) {
    return product_list.slice(0, max_count);
  }

  const expose_count = Math.floor(product_list.length / column);
  return product_list.slice(0, expose_count * column);
}

const SC = {
  Container: styled.div`
    position: relative;
    background-color: ${white};

    .best_product {
      padding: 10px 16px;
      margin: 20px 0 4px;
    }
  `,
};

export default SearchProductList;
